import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const ContainerWrapper = styled.div`
    div.row-header {
        background-color: #dfe7f1;
        height: 26px;
        display: flex;
        align-items: center;
    }

    div.col-xs-6.header,
    div.col-xs-3.header {
        font-weight: bold;        
    }

    .row-tbody > .row:nth-child(even) {
        background-color: #F2F2F2;
    }

    .row-tbody > .row > .col-left {
        border-left: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }

    .row-tbody > .row > .col-right {
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }
`;

export const RowWrapper = styled.div`
    div.col-xs-6,
    div.col-xs-3 {
        text-align: center;
        padding-top: 1px;
        padding-bottom: 1px;
    }
`;

export const TableWrapper = styled(Table)`
    margin-bottom: 500px;

    // & > thead {
    //     position: sticky;
    //     top: 50px;
    //     background: white;
    // }

    & > thead > tr {
        background-color: #dfe7f1 !important;
    }

    & > thead > tr > th {
        position: sticky;
        top: 0px;
        background-color: #dfe7f1 !important;
    }

    & > thead > tr > th {
        text-align: center;
        font-weight: bold;
        height: 28px;
        padding: 3px;
        position: sticky;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding: 3px;
    }

    .glyphicon {
        position: static;
    }

    & > tbody > tr.pediatric-recipient {
        background-color: yellow;
    }

    & > tbody > tr.ssd-donor {
        background-color: #cce6ff;
    }

    & > tbody > tr.ssd-donor-td-recipient {
        background-color: #ffcccc;
    }

    & > tbody > tr.ssd-donor-recipient {
        background-color: #AAFFAA;
    }

       & > tbody > tr.ssd-donor-recipient-cprA {
        background-color: #f57171;
    }

    & > tbody > tr {
        background-color: white;
    }

    .position-abo {
        text-wrap: nowrap;
    }

    .label-black {
        background-color: #000;
        color: #fff;
    }

    .label-red {
        background-color:#dc3546;
        color: #fff;
    }

    .label-grey {
        background-color: #808080; /* Medium Grey */
        color: #fff;
    }

   .ip-btn-yellow {
        background-color: #ffeb3b; /* actual yellow */
        color: #000; /* black text for contrast */
        border-color: #e0c200;
    }

    @media (max-width: 1920px) {
        font-size: 12px;
    }
`;


export const MatchResultsTableWrapper = styled(Table)`

    & > thead > tr {
        background-color: #dfe7f1 !important;
    }

    & > thead > tr > th {
        position: sticky;
        top: 30px;
        background-color: #dfe7f1 !important;
    }

    & > thead > tr > th {
        text-align: center;
        font-weight: bold;
        height: 28px;
        padding: 3px;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding: 3px;
    }

    .glyphicon {
        position: static;
    }

    & > tbody > tr.pediatric-recipient {
        background-color: yellow;
    }

    & > tbody > tr.ssd-donor {
        background-color: #cce6ff;
    }

    & > tbody > tr.ssd-donor-td-recipient {
        background-color: #ffcccc;
    }

    & > tbody > tr.ssd-donor-recipient {
        background-color: #AAFFAA ;
    }

    & > tbody > tr.ssd-donor-recipient-cprA {
        background-color: #f57171;
    }


    & > tbody > tr {
        background-color: white;
    }

    .position-abo {
        text-wrap: nowrap;
    }

    .label-black {
        background-color: #000;
        color: #fff;
    }

    .label-red {
        background-color:#dc3546;
        color: #fff;
    }

    .label-grey {
        background-color: #808080; /* Medium Grey */
        color: #fff;
    }

   .ip-btn-yellow {
        background-color: #ffeb3b; /* actual yellow */
        color: #000; /* black text for contrast */
        border-color: #e0c200;
    }

    .chain-start-row > td {
    border-top: 2px solid #73a4d9;
}

`;

export const GridWrapper = styled.div`
    width: 100%;
    height: 250px;

    margin-bottom: 5px;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #dfe7f1;
        color: #000;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: 700;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        overflow-y: scroll;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        // line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-cell-first-column {
        border-bottom: none;
        text-align: center;
        // line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left-color: transparent;
    }

    .list-header {
        display: flex;
        justify-content: center;
        // align-items: flex-end;
        // padding-bottom: 4px;
        color: #000;
        font-weight: 700;
        padding-top: 2px;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;